namespace advisorop.components.common {

    class SelectCuTitleController {
        titles: Array<domains.ITitle> = [];
        investors: Array<domains.IInvestor> = [];
        isTitleFormVisible: boolean = false;

        selTitle: domains.ITitle;
        titleName: string;
        titleType: number;

        onTitleSelected: any;

        static $inject = ["advisorService", "generalService"];
        constructor(public advisorService: services.AdvisorService, public generalService: services.GeneralService) {
        }

        selectTitle(title: domains.ITitle): void {
            this.selTitle = title;
            this.onTitleSelected({ title: this.selTitle });
        };

        $onInit(): void {
            this.isTitleFormVisible = false;            
        };

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }                        
            for (var key in evt) {
                if (key === "investors") {
                    if (this.selTitle == null) {
                        if (this.investors.length == 1)
                            this.titleType = 0; //individual
                        else if (this.investors.length == 2)
                            this.titleType = 2; //custodian
                        else
                            this.titleType = 1; //joint
                    }
                    else
                        this.titleType = this.selTitle.titleType;
                }
                else if (key === "titles" && this.selTitle == null)
                {
                    if (this.titles.length > 0) {
                        this.selectTitle(this.titles[0]);
                    }
                    else
                        this.selectTitle(null);
                }
            }
        }

        $routerOnActivate(next, previous) {
        };

        //search(searchTerm: string): ng.IPromise<{}> {

        //    this.titleName = searchTerm;

        //    return this.advisorService.searchTitles(searchTerm, this.titleType).then((response) => {
        //        if (response.data.length <= 0)
        //            this.model = null;
        //        return response.data;
        //    });
        //};

        selTitleChanged(): void {
            if (this.selTitle != null) {
                this.titleType = this.selTitle.titleType;
                this.isTitleFormVisible = false;                
            }
            this.onTitleSelected({ title: this.selTitle });
        };
        
        getTitle(id: number): ng.IPromise<domains.ITitle> {
            return this.advisorService.getTitle(id)
                .then((data) => {
                    //this.model = data.data;
                    return data.data;
                }, err => this.generalService.showError(err));
        };

        resetForm(): void {
            this.titleName = "";
            this.isTitleFormVisible = false;
        };

        initNewTitle(): void {
            if (this.isTitleFormVisible) {
                this.isTitleFormVisible = false;
                if (this.titles.length > 0)
                    this.selectTitle(this.titles[0]);
            }
            else {
                this.isTitleFormVisible = true;
                this.selectTitle(null);
            }
        };
        

        createTitle(): void {
            let newTitle: domains.ITitle = {
                titleType: this.titleType,
                accounts: [],
                companyGroup: null,
                companyGroupId: 0,
                id: 0,
                investors: [],
                name: this.titleName
            };

            for (var i = 0; this.investors.length > i; i++)
                newTitle.investors.push({ id: 0, investor: null, investorId: this.investors[i].id, relationType: 0, titleId: 0, titleName: "" });

            this.advisorService.createTitle(newTitle)
                .success((data) => {
                    toastr.success("You have successfully created new title");
                    this.titles.push(data);
                    this.selectTitle(data);
                    this.isTitleFormVisible = false;
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });
        };
      
    }



    class SelectCuTitle implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                titles: "<",
                investors: "<",
                onTitleSelected: "&"
            };
            this.controller = SelectCuTitleController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/select-cu-title.html';
        }
    }
    angular.module(Constants.APP).component("selectCuTitle", new SelectCuTitle());


}